module.exports = __webpack_public_path__ + "img/PMK_20220514_1.5f12af2b.png";